function OffenderSchedule() {
    "use strict";
    var lDate = new Date(),
        lStartDate = new Date(),
        lEndDate = new Date();

    this.__type = 'OffenderSchedule:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    lEndDate.setHours(3);
    lEndDate.setMinutes(0);
    this.EndTime = lEndDate;
    this.IsActive = true;
    this.IsFriday = false;
    this.IsMonday = false;
    this.IsNoSchedule = false;
    this.IsRecurring = true;
    this.IsSaturday = false;
    this.IsSunday = false;
    this.IsThursday = false;
    this.IsTuesday = false;
    this.IsWednesday = false;
    this.Name = '';
    lStartDate.setHours(0);
    lStartDate.setMinutes(0);
    this.StartTime = lStartDate;
    this.EnrolleeId = -1;
    this.OrganizationId = -1;
    this.EntityId = -1;
    this.IsForcedLeave = false;
    this.ScheduleType = -1;
    this.ZoneScheduleType = -1;
    this.IsEnabled = true;
    this.TransactionId = '';
    this.TitleUpdatedFlag = false;
    this.CreateAutoExceptionFlag = 0;
    this.TravelScheduleFlag = false;
    this.StartTimeLocal = "01/01/2001 12:00:00 AM";
    this.EndTimeLocal = "01/01/2001 11:59:00 PM"

}
if (typeof exports !== 'undefined') {
    module.exports = OffenderSchedule;
}